import { render, staticRenderFns } from "./Accomplishments.vue?vue&type=template&id=185ef49a&scoped=true"
import script from "./Accomplishments.vue?vue&type=script&lang=js"
export * from "./Accomplishments.vue?vue&type=script&lang=js"
import style0 from "./Accomplishments.vue?vue&type=style&index=0&id=185ef49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ef49a",
  null
  
)

export default component.exports